import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';

import { ServiceResponse } from "@common/data-models/service/service-response";

import { NomWebServicesJson } from "@common/services/nom-web-services-json";


export type PersonalSettings = {
    DefaultTimeZone?: string,
    DefaultLanguage?: string,
    Rtl?: boolean,
    DayOfWeek?: number,
    DarkMode?: boolean
}

@Injectable({ providedIn: 'root' })
export class PersonalSettingsService {
    constructor(
        public nomWebServicesJson: NomWebServicesJson
    ) {
    }

    public async updatePersonalSettings(settings: PersonalSettings): Promise<ServiceResponse<boolean>> {
        let response: HttpResponse<any> = null;
        try {
            const { DefaultTimeZone, DefaultLanguage, Rtl, DayOfWeek, DarkMode } = settings;
            response = await this.nomWebServicesJson.post(
                "/api/Configuration/PersonalSettings",
                {
                    DefaultTimeZone,
                    DefaultLanguage,
                    Rtl,
                    DayOfWeek,
                    DarkMode
                }, {
                headers: new HttpHeaders({
                    "Content-Type": "application/json",
                    "X-ENPS-TOKEN": this.nomWebServicesJson.NomTokenId
                }),
                responseType: 'json',
                observe: 'response'
            });
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: "Failed to update Personal timezone!",
                detailMessage: `Failed to update Personal timezone! \n\rStackTrace: NomWebServicesJson.updatePersonalSettings(); \n\rError: ${error}`
            });
            return new ServiceResponse<boolean>(false, false);
        }

        return new ServiceResponse<boolean>(true, response.body);
    }

    public async updatePersonalNotificationSettings(settings: any): Promise<ServiceResponse<boolean>> {
        let response: HttpResponse<any> = null;
        try {
            response = await this.nomWebServicesJson.put(
                "/api/PSTNotificationSettings",
                settings,
                {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json",
                        "X-ENPS-TOKEN": this.nomWebServicesJson.NomTokenId
                    }),
                    responseType: 'json',
                    observe: 'response'
                });
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: "Failed to update Personal notification settings!",
                detailMessage: `Failed to update Personal notification settings! \n\rStackTrace: NomWebServicesJson.updatePersonalNotificationSettings(); \n\rError: ${error}`
            });
            return new ServiceResponse<boolean>(false, false);
        }
    }

}
